// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
   apiKey: "AIzaSyBQ-NtNXv3MTglWU9YYBwSDs9W9NJ7YXY0",
   authDomain: "asp-mvc-19036.firebaseapp.com",
   projectId: "asp-mvc-19036",
   storageBucket: "asp-mvc-19036.appspot.com",
   messagingSenderId: "212018074716",
   appId: "1:212018074716:web:f0253f4157b7674e0e8299",
   measurementId: "G-6EBT9QPRGG",
 },
 // appUrl :"http://192.168.1.58:4200/",
    apiUrl : window['_api_domain'] + "/" ,
 // apiUrl:"http://ecommercedev.boniantech.com/khayraat/", 
  // apiUrl: "http://localhost:65121/"
  // apiUrl: "https://localhost/boniantech.ECommerce.presentation/",
  //apiUrl: "https://ecommerce.boniantech.com/",
   imageUrl:"http://erp.boniantech.com/" + window['saasName'] + "/Api/ApiAttachment/DownloadFile",
  //imageUrl:"http://erpdev.boniantech.com/tamara-agri/Api/ApiAttachment/DownloadFile",
  //apiUrl: "http://localhost/boniantech.ECommerce.presentation/"
 //apiUrl: "https://test.boniantech.com/erp/"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
